var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup d-flex justify-content-center align-items-center",
      class: { "popup--visible": _vm.is_open },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row d-flex justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-10 col-lg-8 popup__container" },
            [
              _c(
                "a",
                {
                  staticClass: "popup__close",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.closePopup.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "popup__close__ico",
                      attrs: {
                        width: "16px",
                        height: "16px",
                        viewBox: "0 0 16 16",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      },
                    },
                    [
                      _c("title", [
                        _vm._v("7761595A-79BC-4696-9D3B-F79F423E42FD"),
                      ]),
                      _vm._v(" "),
                      _c("desc", [_vm._v("Created with sketchtool.")]),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "desktop_design",
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "cart",
                                transform: "translate(-512.000000, -28.000000)",
                                stroke: "#93999C",
                                "stroke-width": "1.4",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "icon/closeGrey",
                                    transform:
                                      "translate(513.000000, 29.000000)",
                                  },
                                },
                                [
                                  _c("line", {
                                    attrs: {
                                      x1: "14",
                                      y1: "0",
                                      x2: "0",
                                      y2: "14",
                                      id: "Stroke-429",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("line", {
                                    attrs: {
                                      x1: "14",
                                      y1: "14",
                                      x2: "0",
                                      y2: "0",
                                      id: "Stroke-430",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "h3",
                  {
                    staticClass:
                      "popup__title font__family--gotham font__weight--medium font__color--gray",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.popup_title) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "popup__desc font__family--gotham font__weight--light font__color--gray-light",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.popup_message) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "button button__size-1 button__font--size-1 button__bg--dark",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.closePopup.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "22",
                          height: "15",
                          viewBox: "0 0 22 15",
                        },
                      },
                      [
                        _c("g", [
                          _c("g", [
                            _c("path", {
                              attrs: {
                                fill: "none",
                                stroke: "#93999c",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-miterlimit": "20",
                                "stroke-width": "1.4",
                                d: "M1 7v0l7 7v0L21 1v0",
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "font__family--gotham font__weight--medium font__color--white",
                      },
                      [
                        _vm._v(
                          "\n                            OK\n                        "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }